import { selectSelectedQueryTool, setSelectedQueryTool } from "../dataWranglerSlice";
import LassoToggleButtons from "../../../components/LassoToggleButtons";
import { useDispatch, useSelector } from "react-redux";
import FilterParticipantsButton from "./ParticipantFilter/FilterParticipantsButton";
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { boxShadows } from '../../../StyleConstants';
import useLocalStorage from '../../../hooks/useLocalStorage';
import { useWizardQuery } from "../../../api/dataWranglerApiSlice";
import { selectSelectedDatabase } from '../../common/databaseSlice';

const ToolSelector = () => {
    const selectedQueryTool = useSelector(selectSelectedQueryTool);
    const selectedDatabase = useSelector(selectSelectedDatabase);
    const dispatch = useDispatch();
    const [queryWizardTooltipSeen, setQueryWizardTooltipSeen] = useLocalStorage("queryWizardTooltipSeen", false);
    const { data: wizardData, isFetching: loading } = useWizardQuery({ database: selectedDatabase });

    const imagingData =
        wizardData?.bids_files?.length > 0 ||
        wizardData?.bids_derivative_files?.length > 0 ||
        wizardData?.files_tabular?.length > 0 ||
        wizardData?.files_concat?.length > 0 ||
        wizardData?.bids_sourcedata?.length > 0;

    if (!loading && !imagingData && selectedQueryTool === "allStudyData") {
        dispatch(setSelectedQueryTool("queryWizard"));
    }

    return (
        <Stack direction="row" gap={2} alignItems="center">
            <FilterParticipantsButton />
            <Box>
                <LassoToggleButtons
                    id="query-wizard-toggle-tool-buttons"
                    color="primary"
                    value={selectedQueryTool}
                    onChange={(e, newValue) => {
                        if (newValue) {
                            dispatch(setSelectedQueryTool(newValue))
                        }
                    }}
                    exclusive
                    buttons={[
                        {
                            label: "All Study Data",
                            value: "allStudyData",
                            disabled: !imagingData,
                        },
                        {
                            label: "Query Wizard",
                            value: "queryWizard",
                        },
                        {
                            label: "Dictionary Query Tool",
                            value: "dictionary",
                        },
                    ]} />
                {!queryWizardTooltipSeen &&
                <Paper
                    sx={{ padding: 3,
                        marginTop: 3,
                        marginRight: 2,
                        boxShadow: boxShadows.levelFive,
                        position: "absolute",
                        right: "12px",
                        zIndex: 5,
                        "&::before": {
                            content: `""`,
                            position: "absolute",
                            top: "-16px",
                            left: "calc(50% + 32px)",
                            width: 0,
                            height: 0,
                            borderLeft: "24px solid transparent",
                            borderRight: "24px solid transparent",
                            borderBottom: "24px solid white",
                        }
                    }}
                >
                    <Stack width={"500px"} gap={3}>
                        <Typography
                            fontWeight={"bold"}
                            fontSize={"18px"}
                            fontFamily={"Roboto"}
                        >
                                Search, Filter, and Export with Ease
                        </Typography>
                        <Typography fontFamily={"Roboto"}>
                                Use Lasso’s Query Wizard and Dictionary Tool to quickly filter and search your study’s tabulated data.
                                See what measures were administered at each visit, then export results in one click as a .csv.
                        </Typography>
                        <Typography fontFamily={"Roboto"} fontWeight={"bold"}>
                                Support for formats like R, Parquet, and Arrow is coming soon!
                        </Typography>
                        <Button
                            variant={"primary"}
                            sx={{ alignSelf: 'flex-end' }}
                            size={"small"}
                            onClick={() => setQueryWizardTooltipSeen(true)}
                        >
                          Got it!
                        </Button>
                    </Stack>
                </Paper>
                }
            </Box>
        </Stack>
    )
}

export default ToolSelector;